import { ServiceCategory } from '@packlink/packlink-sdk';

const ServiceChipFilter = {
  ...ServiceCategory,
  ALL: 'all',
  CONTRACTS: 'your-contracts'
};
let ServiceListEvents = /*#__PURE__*/function (ServiceListEvents) {
  ServiceListEvents["SERVICES"] = "services";
  ServiceListEvents["DROPOFF"] = "dropoff";
  ServiceListEvents["DETAILS"] = "details";
  ServiceListEvents["PRICES"] = "prices";
  return ServiceListEvents;
}({});
let ServiceListFilters = /*#__PURE__*/function (ServiceListFilters) {
  ServiceListFilters["CHIPS"] = "chips";
  ServiceListFilters["SIDEPANEL"] = "sidePanel";
  return ServiceListFilters;
}({});
let ServiceTypes = /*#__PURE__*/function (ServiceTypes) {
  ServiceTypes["DROPOFF"] = "drop off";
  ServiceTypes["COLLECTION"] = "collection";
  ServiceTypes["PICKUP"] = "pick up";
  ServiceTypes["DELIVERY"] = "delivery";
  return ServiceTypes;
}({});
let ServiceSortingOptions = /*#__PURE__*/function (ServiceSortingOptions) {
  ServiceSortingOptions["TAGGED_SERVICES"] = "taggedServices";
  ServiceSortingOptions["BASE_PRICE"] = "basePrice";
  ServiceSortingOptions["TRANSIT_TIME"] = "transitTime";
  return ServiceSortingOptions;
}({});

export { ServiceChipFilter, ServiceListEvents, ServiceListFilters, ServiceSortingOptions, ServiceTypes };
//# sourceMappingURL=types.js.map
